import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/two-children-kissing-their-mother-on-the-cheek.webp';
import financialPlanningImageMobileWebp from './images/two-children-kissing-their-mother-on-the-cheek-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='long-term-care-planning-financial-planning'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      headingText={<>Care that&#39;s there when you <WidowBlock>need it.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            From nurses or health aides at your home to an assisted living facility, adult day care center, nursing home, or hospice facility, planning for your long&#45;term care can help put you in a better position to choose what&#39;s right for you. Even if you&#39;re not the one who needs it, there&#39;s a good chance you&#39;ll need to help plan for the long&#45;term care for a loved one.<sup>2</sup> Find out how long the average person needs long&#45;term care.
          </Typography>
          <Link
            id='long-term-care-planning-financial-planning-section-1-read-the-article'
            variant='buttonLinkPrimary'
            linkUrl='/life-and-money/how-long-does-the-average-person-need-long-term-care/'
            ariaLabel='Read our article about long term care'>
            Read the article
          </Link>
        </>
      )}
      // image props
      imageAltText='Two children kissing their mother on the cheek at the beach.'
      imageSrcDefault={financialPlanningImageWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
